import React, { useRef, useState } from 'react';

const Tooltip = ({
    id = 'tooltip',
    text,
    disabled = false,
    marginTopAdjustment = 0,
    marginLeftAdjustment = 0,
    iconMarginTop = 0,
    containerStyle,
    ...props
}) => {
    const node = useRef();

    containerStyle = {
        position: 'relative',
        display: 'inline-flex',
        ...containerStyle
    };

    const tooltipStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 18,
        minWidth: 43,
        backgroundColor: '#414141',
        color: '#CCCCCC',
        fontSize: 12,
        fontWeight: 500,
        textAlign: 'center',
        position: 'absolute',
        zIndex: 100,
        visibility: 'visible',
        ...props.style
    };

    const positionStyle = {
        marginTop:
            (node.current ? node.current.clientHeight + 10 : 0) +
            marginTopAdjustment,
        marginLeft:
            (node.current
                ? node.current.clientWidth / 2 - tooltipStyle.minWidth / 2
                : 0) + marginLeftAdjustment
    };

    const [isVisible, setIsVisible] = useState(false);

    return (
        <div
            style={{ ...containerStyle, marginTop: iconMarginTop }}
            ref={node}
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
        >
            {props.children}
            {isVisible && !disabled && text !== '' && (
                <div id={id} style={{ ...tooltipStyle, ...positionStyle }}>
                    {text}
                </div>
            )}
        </div>
    );
};

export default Tooltip;
